import React from "react"
import ManageTrailerManagement from "./ManageTrailerManagement"

const AddTrailerManagement = () => {
   return <ManageTrailerManagement />
}

export default AddTrailerManagement
